import React, { useState } from "react";
import styled from "styled-components/macro";
import { Button as AntdButton } from "antd";
import { DefaultFont } from "../../../styles/fonts";
import { useGetUserPreview } from "../../../API/queries/userApiQueries";
import { DialogWrapper } from "../../containers";
import { StudentAboutInfo } from "../../../pages/ProfileUser/StudentAboutInfo";
import Modal from "../../Modal";

export const Root = styled(AntdButton)`
  ${DefaultFont};
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }


  color: ${(p) => p.theme.colors.chatTextColor};
`;
export const ViewProfileButton: React.FC<{
  userId: string;
  children: React.ReactNode;
  className?: string;
}> = ({ userId, className, children }) => {
  const [showUserPreviewModal, setShowUserPreviewModal] = useState(false);

  const { data: previewUserData, fetchStatus } = useGetUserPreview(
    showUserPreviewModal ? userId : undefined
  );

  return (
    <>
      <Root
        className={className}
        loading={fetchStatus === "fetching"}
        type="text"
        onClick={() => {
          setShowUserPreviewModal(true);
        }}
      >
        {children}
      </Root>
      {showUserPreviewModal && previewUserData && (
        <Modal isShow={true} handleClose={() => setShowUserPreviewModal(false)}>
          <DialogWrapper style={{ gridTemplateRows: "repeat(2, auto)" }}>
            <StudentAboutInfo
              {...previewUserData}
              closeBtn={() => setShowUserPreviewModal(false)}
            />
          </DialogWrapper>
        </Modal>
      )}
    </>
  );
};
